import type { BusinessTranslationKeys } from "./business_en";

export const business_sv: Record<BusinessTranslationKeys, string> = {
  feed_empty_title: "Tomt här",
  feed_empty_desc: "Bli först med att lägga till något i feeden",

  menu_home: "Hem",
  menu_calendar: "Kalender",
  menu_tasks: "Att göra",
  menu_info: "Info",
  menu_members: "Medlemmar",

  feed_edit_item: "Redigera...",
  feed_mention_tip: "Tips: Använd @ och # för att se förslag",
  feed_intro_text: "Gick med och fixade profilen! 🎉",
  feed_task_status_updated: "Slutförde detta.",
  feed_share_text: "Dela något nytt med din grupp...",
  feed_media: "Media",
  feed_shoutout: "Basunera",
  feed_post: "Posta",
  feed_image_preview: "Förhandsgranskning",

  manage_sheet_more: "Mera val",
  manage_sheet_like: "Gilla",
  manage_sheet_edit: "Redigera",
  manage_sheet_add_pin: "Sätt som Pinnad",
  manage_sheet_remove_pin: "Ta bort som Pinnad",
  manage_sheet_show: "Visa",
  manage_sheet_hide: "Göm",
  manage_sheet_delete: "Ta bort",
  manage_sheet_report: "Rapportera",

  feed_reactions: "Reaktioner",
  feed_content_hidden: "Detta innehåll är gömt...",
  feed_content_deleted: "Detta innehåll är borttaget...",
  feed_content_reported: "Detta innehåll är rapporterat...",
  feed_comment: "Kommentera",
  feed_like: "Gilla",
  feed_load_comments: "Ladda flera kommentarer",
  feed_add_comment: "Kommentera...",
  feed_replies: "svar",
  feed_reply: "Svara",
  feed_content_edited: "Redigerat...",
  feed_edit_comment: "Redigera...",
  feed_load_replies: "Ladda flera svar",
  feed_reply_now: "Svara...",
  feed_edit_reply: "Redigera...",
  date_due: "Senast",
  date: "Datum",
  description: "Beskrivning",
  save: "Spara",
  completed: "Avklarat",
  completed_this: "slutförde detta",
  completed_this_total: "Totalt har {{count}} slutfört detta",
  skipped_this_total: "({{count}} 'Inte för mig')",
  completed_this_total_one: "Totalt har {{count}} slutfört detta",
  edit: "Redigera",
  delete: "Ta bort",
  include_user: "Inkludera",
  exclude_user: "Exkludera",
  completed_by_everyone: "Slutfört av alla",
  completed_by_count: "Slutfört av",
  you_have_completed_this: "Du har slutfört detta",
  you_set_as_completed: "Sätt som slutförd",
  you_have_skipped_this: "Satt som 'Inte för mig'",
  set_task_as_skipped_title: "Uppgiften sätts som 'Inte för mig' men avklarad.",
  set_task_as_skipped_desc: "Du kan ändra dig när som helst.",
  skipped_this: "'Inte för mig'",
  task_this_is_not_for_me: "Det här är inte något för mig...",
  tasks_progress_summary:
    "Du har slutfört {{completed}}/{{total}} uppgifter ({{percentage}}%)",
  show_completed_tasks_one: "Visa min {{count}} slutförda uppgift",
  show_completed_tasks: "Visa mina {{count}} slutförda uppgifter",
  completed_already_info: "You har satt detta som avklarat.",
  add_task: "Lägg till uppgift",
  schedule_start: "Start",
  schedule_end: "Slut",
  schedule_title: "Titel",
  schedule_add_row: "Lägg till rad",
  schedule_date: "Datum",
  schedule_add: "Schema",
  event_loading: "Snart så...",
  when_ready: "När du är redo...",
  complete_profile: "Gör klart din profil",
  not_here_yet: "Inte här än...",
  members: "Deltagare",
  next_up: "Nästa",
  lets_go: "Visa",
  intro_title: "👋 Välkommen!",
  from_customer_label: "Från {{name}}",
  intro_instructions:
    "För att komma igång, slutför stegen nedan - presentera dig själv.",
  button_ready: "Jag är redo!",
  button_complete_profile: "Fyll i din profil ovan",
  button_skip: "Hoppa över",
  team: "Grupp",

  gate_welcome_title: "Välkommen!",
  gate_join_instructions:
    "Gå med genom att använda den e-postadress inbjudan skickades till.",
  gate_error_not_found: "Tyvärr – hittades inte",
  gate_email_placeholder: "Din e-postadress",
  gate_button_confirm: "Bekräfta e-postadress",
  gate_confirmation_info:
    "Eftersom du är här har du fått en länk till det här eventet. Genom att bekräfta din e-postadress får du tillgång till innehållet och läggs till som medlem.",

  /* --- CurrentTeamOrJoinList Component Keys --- */
  current_team_default_name: "Min grupp",
  team_button_leave: "Lämna",
  team_create_label: "Skapa en grupp",
  team_create_instructions:
    "Skapar du nya minnen med andra? I så fall, skapa en grupp så att de kan gå med i din.",
  team_join_label: "Gå med i en grupp",
  team_join_instructions:
    "Skapar du nya minnen med något av dessa grupper? I så fall, gå med nu för att ansluta och presentera dig som en del av teamet.",
  team_button_join: "Gå med",
  team_start_own_instructions:
    "Om du inte hittade någon lämplig grupp kan du starta ditt egna, så att andra enkelt kan gå med dig.",
  team_button_create: "Skapa grupp",

  section_button_next: "Nästa",
  section_title_looks: "Ditt utseende",
  section_label_looks: "Ditt utseende",
  profile_placeholder_display_name: "Ange ditt visningsnamn",
  section_title_questions: "Profilfrågor",
  section_label_questions: "Profilfrågor",
  profile_placeholder_answer: "Ditt svar...",
  section_title_presentation: "Presentation",
  section_label_presentation: "Presentation",
  profile_placeholder_presentation: "Presentera dig själv med dina egna ord..",
  section_title_team: "Min grupp",
  screen_title_profile: "Profil",
  feed_filter_by: "Filtrera på",
  feed_mentions: "Omnämnanden",

  today: "Idag",

  mention_people: "Deltagare",
  mention_groups: "Grupper",
  mention_events: "Event",
  mention_tasks: "Uppgift",
  mention_info: "Info",
} as const;
